import LocalDatabase from '@/includes/db';
import { Schema } from '@/includes/definitions/index.d';
import { CardGameHistory } from '@/includes/definitions/word.d';

const schema = {
  name: 'AnkiGameHistory',
  keyPath: 'id',
  autoIncrement: true,
  timestamps: true,
  schema: {
    id: { unique: true },
    title: { unique: false },
    score: { unique: false },
    cards: { unique: false },
  },
} as Schema;

export const AnkiGameHistoryModel = LocalDatabase.MakeModel<CardGameHistory>(schema);
export default schema;
